import React from "react"

import { Hero } from "./components/Hero/Hero"
import { History } from "./components/History/History"

export const Dividends: React.FC = () => {
  return (
    <>
      <Hero />
      <History />
    </>
  )
}
